<script setup lang="ts">
import { IImage } from '@/interfaces';
import BaseOverlay from '@/overlays/BaseOverlay.vue';
import MediaPreviewOverlay from '@/overlays/MediaPreviewOverlay.vue';
import PicturesGrid from '@/views/shared/PicturesGrid.vue';
import { computed, ref } from 'vue';

const emit = defineEmits(['close', 'close-preview']);

interface Props {
  pictures: IImage[];
  isPersonalMedia?: boolean;
}

const props = withDefaults(defineProps<Props>(), {});

const showMediaPreview = ref<boolean>(false);
const selectedMediaIndex = ref<number>(-1);

const pictureSources = computed(() => {
  return props.pictures.map((picture: IImage) => picture.source);
});

const pictureSelected = (index: number) => {
  selectedMediaIndex.value = index;
  showMediaPreview.value = true;
};
</script>

<template>
  <div>
    <BaseOverlay
      @close="emit('close')"
      :title="isPersonalMedia ? $t('media.myImages') : $t('global.images')"
    >
      <template #content>
        <p class="text-neutral-1000"></p>
        <PicturesGrid
          :pictures="pictureSources"
          @picture-selected="pictureSelected"
        />
      </template>
    </BaseOverlay>

    <MediaPreviewOverlay
      v-if="showMediaPreview"
      media-type="pictures"
      :selected-item-index="selectedMediaIndex"
      :items="pictures"
      :allow-archive-remove="isPersonalMedia"
      @close-preview="showMediaPreview = false"
    />
  </div>
</template>
